var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ElementRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
import { ContextMenu } from 'common/core/ui/context-menu/context-menu.service';
import { DriveContextMenuComponent } from '../../context-actions/components/drive-context-menu/drive-context-menu.component';
import { ToggleDetailsSidebar, SetViewMode } from '../../state/actions/commands';
var ToolbarActionsComponent = /** @class */ (function () {
    function ToolbarActionsComponent(store, contextMenu) {
        this.store = store;
        this.contextMenu = contextMenu;
    }
    ToolbarActionsComponent.prototype.toggleViewMode = function () {
        this.store.dispatch(new SetViewMode());
    };
    ToolbarActionsComponent.prototype.ToggleDetails = function () {
        this.store.dispatch(new ToggleDetailsSidebar());
    };
    ToolbarActionsComponent.prototype.openMoreActionsMenu = function () {
        var entry = this.store.selectSnapshot(DriveState.selectedEntry);
        this.contextMenu.open(DriveContextMenuComponent, this.moreActionsButton.nativeElement, { data: { entry: entry } });
    };
    __decorate([
        Select(DriveState.anythingSelected),
        __metadata("design:type", Observable)
    ], ToolbarActionsComponent.prototype, "anythingSelected", void 0);
    __decorate([
        Select(DriveState.viewMode),
        __metadata("design:type", Observable)
    ], ToolbarActionsComponent.prototype, "viewMode", void 0);
    __decorate([
        Select(DriveState.detailsOpen),
        __metadata("design:type", Observable)
    ], ToolbarActionsComponent.prototype, "activityOpen", void 0);
    __decorate([
        Select(DriveState.multipleEntriesSelected),
        __metadata("design:type", Observable)
    ], ToolbarActionsComponent.prototype, "multipleEntriesSelected$", void 0);
    return ToolbarActionsComponent;
}());
export { ToolbarActionsComponent };
